/**
 * The single async storage adapter of ADR 0005 / spec 3.4: the only place the client persists
 * anything, holding nothing but the refresh token and one UI preference. Async and keyed by a
 * closed union so it can be swapped for `@capacitor/preferences` without touching a caller.
 * Every access is wrapped: a private window, cleared site data or a blocked origin all make
 * `localStorage` throw, and the app must still work (it just forgets the last class number).
 */

export type StorageKey = "refreshToken" | "lastClassNumber";

const PREFIX = "scrolivo.";

export const storage = {
  async get(key: StorageKey): Promise<string | null> {
    try {
      return window.localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  async set(key: StorageKey, value: string): Promise<void> {
    try {
      window.localStorage.setItem(PREFIX + key, value);
    } catch {
      // A viewer with storage blocked simply re-types the class number.
    }
  },
  async remove(key: StorageKey): Promise<void> {
    try {
      window.localStorage.removeItem(PREFIX + key);
    } catch {
      // Nothing to do: the value was never readable in the first place.
    }
  },
};
